import React, { useEffect } from 'react';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

const CookieBanner = () => {
    useEffect(() => {
        CookieConsent.run({
            guiOptions: {
                consentModal: {
                    layout: "cloud",
                    position: "bottom center",
                    equalWeightButtons: true,
                    flipButtons: false
                },
                preferencesModal: {
                    layout: "box",
                    position: "right",
                    equalWeightButtons: true,
                    flipButtons: false
                }
            },
            categories: {
                necessary: {
                    readOnly: true
                },
                analytics: {}
            },
            language: {
                default: "fr",
                autoDetect: "browser",
                translations: {
                    fr: {
                        consentModal: {
                            title: "Bonjour, c'est l'heure des cookies !",
                            description: "Ce site utilise des cookies essentiels pour assurer son bon fonctionnement et des cookies de suivi pour comprendre comment vous interagissez avec lui. Ces derniers ne seront fixés qu'après votre consentement.",
                            acceptAllBtn: "Tout accepter",
                            acceptNecessaryBtn: "Tout refuser",
                            showPreferencesBtn: "Personnaliser"
                        },
                        preferencesModal: {
                            title: "Préférences de confidentialité",
                            acceptAllBtn: "Tout accepter",
                            acceptNecessaryBtn: "Tout refuser",
                            savePreferencesBtn: "Enregistrer mes choix",
                            closeIconLabel: "Fermer le modal",
                            serviceCounterLabel: "Service|Services",
                            sections: [
                                {
                                    title: "Utilisation des cookies",
                                    description: "Je souhaite adapter votre expérience à vos besoins. Vous pouvez choisir pour chaque catégorie les cookies que vous souhaitez autoriser."
                                },
                                {
                                    title: "Cookies strictement nécessaires <span class=\"pm__badge\">Toujours Actif</span>",
                                    description: "Ces cookies sont essentiels au bon fonctionnement de notre site web.",
                                    linkedCategory: "necessary"
                                },
                                {
                                    title: "Cookies d'analyse",
                                    description: "Ces cookies permettent au site web de se souvenir des choix que vous avez faits par le passé et d'analyser vos interactions sur le site.",
                                    linkedCategory: "analytics"
                                }
                            ]
                        }
                    }
                }
            }
        });
    }, []);

    return null; // The banner is detached from standard React hierarchy 
};

export default CookieBanner;
